// Создаем конфигурацию из переменных окружения
const config = {
    API_BASE_URL: "https://elitelegion.ru/api",
    //API_BASE_URL: "http://localhost:8080/api",
    BASE_URL: "https://elitelegion.ru"
};

export default config;
